/* eslint-disable */
function getIntoList(index) {
  return new Promise(function(resolve, reject) {
    let result = {
      "code": 0,
      "next": 1,
      "topupList": [{
        "orderId": "129934",
        "amount": 100,
        "status": "1",
        "topupTime": 1234567890
      },
      {
        "orderId": "1098235",
        "amount": 200,
        "status": "2",
        "topupTime": 1234567890
      },
      {
        "orderId": "222235",
        "amount": 300,
        "status": "2",
        "topupTime": 1234567890
      },
      {
        "orderId": "9288835",
        "amount": 1000,
        "status": "2",
        "topupTime": 1234567890
      },
      {
        "orderId": "212122235",
        "amount": 100,
        "status": "2",
        "topupTime": 1234567890
      },
      {
        "orderId": "2009235",
        "amount": 500,
        "status": "1",
        "topupTime": 1234567890
      }]
    }
    if(index === 1) {
      result.next = 0
    }
    setTimeout(() => {
      resolve(result)
    }, 2000)
  })
}

function getOutList() {
  let result = {
    "code": 0,
    "next": 1,
    "withdrawList": [{
      "orderId": "129934",
      "amount": 100,
      "status": "1",
      "withdrawTime": 1234567890
    },
    {
      "orderId": "1098235",
      "amount": 200,
      "status": "2",
      "withdrawTime": 1234567890
    },
    {
      "orderId": "222235",
      "amount": 300,
      "status": "2",
      "withdrawTime": 1234567890
    },
    {
      "orderId": "9288835",
      "amount": 400,
      "status": "2",
      "withdrawTime": 1234567890
    },
    {
      "orderId": "212122235",
      "amount": 500,
      "status": "2",
      "withdrawTime": 1234567890
    },
    {
      "orderId": "2009235",
      "amount": 600,
      "status": "1",
      "withdrawTime": 1234567890
    }]
  }
  return new Promise(function(resolve, reject) {
    setTimeout(() => {
      resolve(result)
    }, 2000)
  })
}

function getIncomeList() {
  let result = {
    "code": 0,
    "next": 1,
    "interestList": [{
        "sn": "qwdsf234",
        "amount": 12,
        "returnTime": 1234567890,
        "remark": "Upfront Interest of 3% annum"
      },
      {
        "sn": "qwdsf235",
        "amount": 21,
        "returnTime": 1234567890,
        "remark": "Upfront Interest of 3% annum",
      }
    ]
  }
  if(Math.random() > 0.5) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(result)
      }, 2000)
    })
  } else {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({})
      }, 2000)
    })
  }
}

export { getIntoList, getOutList, getIncomeList }



// WEBPACK FOOTER //
// ./src/api/index.js